var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('OmniCheckboxes', {
    staticClass: "list",
    attrs: {
      "draggable": "",
      "hide-checkboxes": "",
      "prepend-numbers": "",
      "options": _vm.options,
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }